import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import { IncidentListItemData } from '../Incidents';

const LAYER_POINT_FILL = 'rgba(30, 64, 175, 1)';
const LAYER_POINT_OUTLINE = 'rgba(30, 58, 138, 1)';

// Only incidents with one of these types get a map icon
export const getIncidentIcon = (incidentTypes: string[]): string | null => {
  for (const incidentType of incidentTypes) {
    const type = incidentType.toLowerCase().trim();

    if (type.includes('world cup')) return 'sports_soccer';
    if (type.includes('fleet week')) return 'anchor';
    if (type.includes('america 250')) return '🇺🇸';
    if (type.includes('sail 250')) return 'sailing';
  }

  return null;
};

export const renderIconToDataUrl = (icon: string, size = 34): string => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2 - 1, 0, 2 * Math.PI);
  ctx.fillStyle = LAYER_POINT_FILL;
  ctx.fill();
  ctx.strokeStyle = LAYER_POINT_OUTLINE;
  ctx.lineWidth = 1.5;
  ctx.stroke();

  // Material Symbols icons are ligature text; emoji use the default font
  const isMaterialIcon = /^[a-z_]+$/.test(icon);
  const fontSize = Math.round(size * 0.55);
  ctx.font = isMaterialIcon
    ? `${fontSize}px "Material Symbols Outlined"`
    : `${fontSize}px sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = '#FFFFFF';
  ctx.fillText(icon, size / 2, size / 2 + 1);

  return canvas.toDataURL('image/png');
};

export const getIncidentIconSymbol = (
  incident: IncidentListItemData
): PictureMarkerSymbol | null => {
  const icon = getIncidentIcon(incident.incidentTypes);
  if (!icon) return null;

  return new PictureMarkerSymbol({
    url: renderIconToDataUrl(icon),
    width: 34,
    height: 34,
  });
};
